import BookviewSearchPanel from "organisms/panels/bookview-tab-panels/bookview-search/bookview-search-panel";
import React from "react";
const CSS_BASE_CLASS = "c-image-viewer-sidebar";
const ImageViewerSidebar = () => {
    return (
        <div className={CSS_BASE_CLASS}>
            <BookviewSearchPanel isInLegacyPublicationView />
        </div>
    );
};

export default ImageViewerSidebar;
